import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { masterConfigurationList } from './core/endpointsAndGeneric-constants/masterConfigList';
import { DataService } from './shared/common-services/data.service';
import { SharedService } from './shared/common-services/shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ECHO';

  constructor(public router: Router, private _sharedService: SharedService, private _dataService: DataService) {
    if (window.self !== window.top) {
      this.router.navigate(['/error']);
    } else {
      this._dataService?.events?.subscribe((res: any) => {
        if (res.name === 'apiRefresh') {
          this._sharedService.getTenantAvailability();
          this._sharedService?.getAttributeDetails(masterConfigurationList);
        } else if (res.name === 'tenantChanged') {
          this._sharedService?.getAttributeDetails(masterConfigurationList);
        }
      });
    }
  }
}
